module.exports = __webpack_public_path__ + "static/media/generatedRevenueIcon.266d674a.svg";